import {
    FoundModule,
    getPageComponent,
    getWidgetComponent,
    registerPageModule,
    registerWidgetModule,
} from "@insite/client-framework/Components/ContentItemStore";
import DelayedSpinner from "@insite/client-framework/Components/DelayedSpinner";
import importChunk from "@insite/client-framework/Components/importChunk";
import MissingComponent from "@insite/client-framework/Components/MissingComponent";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import PageModule from "@insite/client-framework/Types/PageModule";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React from "react";

type Props = { isWidget: boolean; type: string } & Partial<HasFields>;

class AsyncComponent extends React.Component<Props, { ComponentToBe: null | any }> {
    constructor(props: Props) {
        super(props);
        const { isWidget, type } = this.props;

        const existingComponent = isWidget ? getWidgetComponent(type) : getPageComponent(type);

        this.state = { ComponentToBe: existingComponent };
    }

    componentDidMount() {
        const { ComponentToBe } = this.state;
        if (!ComponentToBe) {
            this.handleImport();
        }
    }

    handleImport = async () => {
        const fn = importChunk[this.props.type];

        if (!fn) {
            return this.setState({ ComponentToBe: MissingComponent });
        }

        const module = await fn();

        this.props.isWidget
            ? registerWidgetModule(module as FoundModule<WidgetModule>, this.props.type)
            : registerPageModule(module as FoundModule<PageModule>, this.props.type);

        this.setState({ ComponentToBe: module.default.component || module.default });
    };

    render() {
        const { isWidget } = this.props;
        const { ComponentToBe: ComponentToBeState } = this.state;
        const ComponentToBe: any = ComponentToBeState;

        if (!ComponentToBe) {
            return <DelayedSpinner isWidget={isWidget} />;
        }

        return <ComponentToBe {...this.props} />;
    }
}

export default AsyncComponent;
